import { createAction } from 'redux-actions';
import * as types from './types';

export const saveButtonClick = createAction(types.SAVE_BUTTON_CLICK);
export const canceleButtonClick = createAction(types.CANCEL_BUTTON_CLICK);
